import {
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
  updateProfile
} from 'firebase/auth'
import { auth } from './firebaseClient'

let persistenceReady = null

function ensurePersistence() {
  if (!persistenceReady) {
    persistenceReady = setPersistence(auth, browserLocalPersistence)
  }
  return persistenceReady
}

export async function loginWithEmail(email, password) {
  await ensurePersistence()
  const credentials = await signInWithEmailAndPassword(auth, email, password)
  return credentials.user
}

export async function registerWithEmail(email, password, displayName) {
  await ensurePersistence()
  const credentials = await createUserWithEmailAndPassword(auth, email, password)
  if (displayName) {
    await updateProfile(credentials.user, { displayName })
  }
  return credentials.user
}

export async function sendPasswordReset(email) {
  await sendPasswordResetEmail(auth, email)
}

export async function logout() {
  await signOut(auth)
}

export function subscribeToAuthState(callback) {
  return onAuthStateChanged(auth, callback)
}

